module.exports = __webpack_public_path__ + "static/media/promptPlaceholder.c02f7650.svg";